import { parseStartDate, parseEndDate } from '../utils/parseDate';
import * as fns from 'date-fns';
import { normalizeBroadcastCountries } from '../reports/broadcastCountries';

const formatHistoryData =
    ({ filters, user, values, rightsholderIds, multipleRightsholders }) =>
    ({ reportUrl, id }) => {
        const startDate = values.startDate && parseStartDate(values.startDate);
        const endDate = values.endDate && parseEndDate(values.endDate);
        const { gumgumUser, firstName, lastName } = user;
        const rightsholdersById = filters.rightsholders.list;
        const sponsorsById = filters.sponsors.list;
        const placementsById = filters.placements.list;
        const broadcastCountries = normalizeBroadcastCountries(
            values.broadcastCountryIds,
            filters.countries?.list,
            values.broadcastCountryNames,
        );
        const placementName =
            values.placement &&
            !multipleRightsholders &&
            placementsById[`${rightsholderIds[0]}-${values.placement}`].name;

        const userDisplayName = gumgumUser
            ? 'Relo'
            : `${firstName} ${lastName}`;
        return {
            addedAt: fns.format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            endDate,
            startDate,
            name: values.reportTitle,
            orderBy: values.sortBy,
            reportUrl,
            id,
            placement: values.placement,
            placementName,
            postImgUrl: values.postImgUrl,
            rightsholder: values.rightsholders,
            rightsholderName: multipleRightsholders
                ? `${rightsholderIds.length} Rightsholders`
                : rightsholdersById[`${rightsholderIds[0]}`].name,
            sponsors: values.sponsors || values.sponsor,
            sponsorName: sponsorsById[`${values.sponsor}`].name,
            createdBy: userDisplayName,
            exportAs: 'PDF',
            ...broadcastCountries,
        };
    };

export default formatHistoryData;
